import { validationFactory } from '../validation/validation';
/**
 * Validator that requires the property's value to match a regex pattern
 *
 * @param pattern A regular expression to be used as is to test the values, or a string. If a string is passed, the ^ character is prepended and the $ character is appended to the provided string (if not already present), and the resulting regular expression is used to test the values
 */
export var pattern = validationFactory('pattern');
//# sourceMappingURL=pattern.js.map